<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="28" height="36" viewBox="0 0 28 36" role="graphics-symbol" aria-hidden="true">
    <title>Bookmark</title>
    <path
      d="M14 31L4.2 35.2C3.2 35.6333 2.25 35.5541 1.35 34.9622C0.45 34.3704 0 33.533 0 32.45V3.75C0 2.95 0.3 2.25 0.9 1.65C1.5 1.05 2.2 0.75 3 0.75H25C25.8 0.75 26.5 1.05 27.1 1.65C27.7 2.25 28 2.95 28 3.75V32.45C28 33.533 27.55 34.3704 26.65 34.9622C25.75 35.5541 24.8 35.6333 23.8 35.2L14 31ZM14 27.8L25 32.45V3.75H3V32.45L14 27.8ZM14 3.75H3H25H14Z"
      fill="currentColor"
    />
  </svg>
</template>
